import React, { useState } from "react";
import { Button, Col } from "reactstrap";
import DonationSlabs from "./donationSlabs";
import FormModal from "./formModal/";
import ImageCarousel from "./imageCarousel";
import RecurringSlabs from "./recurringSlabs";

const Donate = () => {
    const amountList = [
        {
            label: "12,000",
            amount: 12000,
            cause: "Support Infant India with ₹ 12,000",
        },
        {
            label: "6,000",
            amount: 6000,
            cause: "Support Infant India with ₹ 6,000",
        },
        {
            label: "3,000",
            amount: 3000,
            cause: "Support Infant India with ₹ 3,000",
        },
        {
            label: "2,000",
            amount: 2000,
            cause: "Support Infant India with ₹ 2,000",
        },
    ];

    const [activeSelection, setActiveSelection] = useState({
        amount: amountList[3].amount,
        cause: amountList[3].cause,
    });

    const isRecurringPayment = false;
    const [isCustomAmount, setIsCustomAmount] = useState(false);
    const [showForm, setShowForm] = useState(false);

    return (
        <>
            <Col sm="6">
                <ImageCarousel
                    activeSelection={activeSelection}
                    amountList={amountList}
                />
            </Col>
            <Col sm="6" className="d-flex flex-column justify-content-between">
                {!isRecurringPayment ? (
                    <DonationSlabs
                        amountList={amountList}
                        activeSelection={activeSelection}
                        setActiveSelection={setActiveSelection}
                        isCustomAmount={isCustomAmount}
                        setIsCustomAmount={setIsCustomAmount}
                    />
                ) : (
                    <RecurringSlabs
                        activeSelection={activeSelection}
                        setActiveSelection={setActiveSelection}
                    />
                )}

                <p
                    className="m-t-20"
                    style={{ fontSize: "1rem", textAlign: "center" }}
                >
                    {activeSelection.cause}
                </p>

                {/* <div className="animate-chk m-t-20">
                    <Label
                        className="d-block"
                        for="onetime-payment"
                        style={{ fontSize: "1rem" }}
                    >
                        <Input
                            className="radio_animated"
                            id="onetime-payment"
                            type="radio"
                            checked={!isRecurringPayment}
                            onChange={(e) => {
                                setIsRecurringPayment(false);
                                setActiveSelection({
                                    amount: amountList[3].amount,
                                    cause: amountList[3].cause,
                                });
                            }}
                        />
                        One Time Donation
                    </Label>
                    <Label
                        className="d-block"
                        for="recurring-payment"
                        style={{ fontSize: "1rem" }}
                    >
                        <Input
                            className="radio_animated"
                            type="radio"
                            id="recurring-payment"
                            checked={isRecurringPayment}
                            onChange={(e) => {
                                setIsRecurringPayment(true);
                                setActiveSelection({
                                    cause: `Support 1 child's softskill education for 6 Months`,
                                    amount: `1000`,
                                    numberOfKids: 1,
                                    numberOfMonths: 6,
                                });
                            }}
                        />
                        Monthly Donation
                    </Label>
                </div> */}
                <div>
                    <Button
                        size="lg"
                        color="primary"
                        className="mt-4 w-100"
                        onClick={() => {
                            activeSelection.amount && setShowForm(true);
                        }}
                    >
                        Support Now
                    </Button>
                </div>
                <div>
                    <FormModal
                        open={showForm}
                        handleClose={() => setShowForm(false)}
                        activeSelection={
                            activeSelection.cause ===
                            "I would like to contribute (Amount of your Choice)"
                                ? {
                                      ...activeSelection,
                                      cause: "Donation to Infant India",
                                  }
                                : activeSelection
                        }
                        isRecurringPayment={isRecurringPayment}
                    />
                </div>
            </Col>
        </>
    );
};
export default Donate;
